









import Vue from "vue";
import Component from "vue-class-component";
import { FeriadosService } from "@/services/feriados.service";
import { Prop } from "vue-property-decorator";

@Component
export default class ComboAno extends Vue {
  loading = false;
  items: number[] = [];
  @Prop() readonly value!: number | null;

  get tipo(): number | null {
    return this.value;
  }
  set tipo(val: number | null) {
    this.$emit("input", val);
  }
  async fetchFeriados() {
    this.loading = true;
    this.items = await FeriadosService.listarAnos();
    this.loading = false;
  }

  mounted() {
    this.fetchFeriados();
  }
}
